module.exports = __webpack_public_path__ + "img/7.a46a1983.png";